document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-thumbnail-grid").forEach(grid => {
    grid.classList.add("is-collapsed");

    const buttons = grid.parentElement.querySelectorAll(".thumbnail-show-more");

    buttons.forEach(button => {
      button.addEventListener("click", () => {
        const expanded = button.dataset.expanded === "true";

        // Keep both buttons in sync
        buttons.forEach(btn => {
          btn.dataset.expanded = expanded ? "false" : "true";
          btn.innerHTML = expanded ? "Alle anzeigen" : "Weniger anzeigen";
        });

        if (expanded) {
          grid.classList.add("is-collapsed");
        } else {
          grid.classList.remove("is-collapsed");
        }
      });
    });
  });
});